var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconChatYellow = function SvgIconChatYellow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.833 33.834c7.732 0 14-6.268 14-14s-6.268-14-14-14-14 6.268-14 14 6.268 14 14 14Z",
    fill: "#FFDA67"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m9.648 27.94 10.185 5.894H7.977c-1.56 0-2.34-1.884-1.237-2.987l2.908-2.908Z",
    fill: "#FFDA67"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.656 21.481a1.648 1.648 0 1 0 0-3.295 1.648 1.648 0 0 0 0 3.295ZM19.833 21.481a1.648 1.648 0 1 0 0-3.295 1.648 1.648 0 0 0 0 3.295ZM26.011 21.481a1.648 1.648 0 1 0 0-3.295 1.648 1.648 0 0 0 0 3.295Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.25 50.167c9.343 0 16.917-7.574 16.917-16.916 0-9.343-7.574-16.917-16.917-16.917-9.343 0-16.917 7.574-16.917 16.917 0 9.343 7.574 16.916 16.917 16.916Z",
    fill: "#FFAD24"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.558 43.045 33.25 50.167h13.799c2.08 0 3.12-2.514 1.65-3.984l-3.138-3.138h-.003Z",
    fill: "#FFAD24"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.714 35.24a1.99 1.99 0 1 0 0-3.978 1.99 1.99 0 0 0 0 3.978ZM33.25 35.24a1.99 1.99 0 1 0 0-3.978 1.99 1.99 0 0 0 0 3.978ZM25.786 35.24a1.99 1.99 0 1 0 0-3.978 1.99 1.99 0 0 0 0 3.978Z",
    fill: "#fff"
  })));
};
export default SvgIconChatYellow;